<div class="geo-checking" *ngIf="validating">
  <i class="fas fa-circle-notch fa-spin"></i><span>Verificando ubicación…</span>
</div>
<div class="geo-error-card" *ngIf="!validating && error">
  <i class="fas fa-map-marked-alt geo-error-card__icon"></i>
  <div class="geo-error-card__body">
    <strong>Dirección fuera de {{ error.municipalityName || 'el municipio seleccionado' }}<ng-container *ngIf="error.departmentName">, {{ error.departmentName }}</ng-container></strong>
    <span><ng-container *ngIf="error.distanceMeters">A {{ error.distanceMeters | number:'1.0-0' }} m del límite · </ng-container>Edita la dirección para que quede dentro del municipio.</span>
    <button *ngIf="showEditButton" mat-stroked-button color="warn" type="button" class="geo-error-card__action" (click)="editAddress.emit()">
      <i class="fas fa-edit mr-1"></i> Editar dirección
    </button>
  </div>
</div>
